import { Injectable } from '@angular/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';

/**
 * German texts for the Material datepicker (toggle, calendar navigation),
 * which otherwise announces English defaults such as "Open calendar".
 */
@Injectable()
export class GermanDatepickerIntl extends MatDatepickerIntl {
  override calendarLabel = $localize`Kalender`;
  override openCalendarLabel = $localize`Kalender öffnen`;
  override closeCalendarLabel = $localize`Kalender schließen`;
  override prevMonthLabel = $localize`Vorheriger Monat`;
  override nextMonthLabel = $localize`Nächster Monat`;
  override prevYearLabel = $localize`Vorheriges Jahr`;
  override nextYearLabel = $localize`Nächstes Jahr`;
  override prevMultiYearLabel = $localize`Vorherige 24 Jahre`;
  override nextMultiYearLabel = $localize`Nächste 24 Jahre`;
  override switchToMonthViewLabel = $localize`Datum auswählen`;
  override switchToMultiYearViewLabel = $localize`Monat und Jahr auswählen`;
  override startDateLabel = $localize`Startdatum`;
  override endDateLabel = $localize`Enddatum`;
  override comparisonDateLabel = $localize`Vergleichszeitraum`;

  override formatYearRangeLabel(start: string, end: string): string {
    return $localize`${start}:start: bis ${end}:end:`;
  }
}
